let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7WD8j")).then(() => parcelRequire('1th0k'));